window._theme = window._theme || {}; 

_theme.focusTrap = function(elem, cb, tabbableAdditionalElems, enableBackwardJourney) {
    let tabbableElems = ['select', 'input', 'textarea', 'button', 'a[href]'];
    
    if (tabbableAdditionalElems) {
      if (Array.isArray(tabbableAdditionalElems)) {
        tabbableElems = tabbableElems.concat(tabbableAdditionalElems);
      } else if (typeof tabbableAdditionalElems === 'string') {
        tabbableElems.push(tabbableAdditionalElems);
      }
    }
  
    const allTabbables = Array.from(elem.querySelectorAll(tabbableElems.join(',')))
      .filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden') && el.offsetParent !== null);
  
    const firstTabbable = allTabbables[0];
    const lastTabbable = allTabbables[allTabbables.length - 1];
  
    if (firstTabbable) firstTabbable.focus();
  
    function handleKeydown(event) {
      const isTab = event.key === 'Tab' || event.keyCode === 9;
      const isEsc = event.key === 'Escape' || event.keyCode === 27;
  
      if (!isTab && !isEsc) return;
  
      if (event.target === lastTabbable && isTab && !event.shiftKey) {
        event.preventDefault();
        if (firstTabbable) firstTabbable.focus();
      }
  
      if (event.target === firstTabbable && isTab && event.shiftKey && !enableBackwardJourney) {
        event.preventDefault();
        if (lastTabbable) lastTabbable.focus();
      }
  
      if (isEsc && typeof cb === 'function') {
        cb(elem);
      }
    }
  
    elem.removeEventListener('keydown', handleKeydown); // in case it was added before
    elem.addEventListener('keydown', handleKeydown);
};
  
document.addEventListener('DOMContentLoaded', () => {
    const skipLink = document.querySelector('.skip-to-content-link');
    const targetLink = document.querySelector('page-header-logo-banner a.hero__button');
  
    if (skipLink && targetLink) {
      skipLink.addEventListener('click', (e) => {
        e.preventDefault();
        targetLink.focus();
      });
    }

    
    const toggleMenus = document.querySelectorAll('[data-toggle-menu]');

    toggleMenus.forEach(menu => {
      menu.addEventListener('click', () => {
        const isExpanded = menu.getAttribute('aria-expanded') === 'true';
        menu.setAttribute('aria-expanded', String(!isExpanded));

        // Scroll lock while any mega submenu is expanded
        const hasAnyHeaderMegaOpen = Array.from(document.querySelectorAll('[data-toggle-menu]'))
          .some(btn => btn.getAttribute('aria-expanded') === 'true');
        if (hasAnyHeaderMegaOpen) {
          document.body.classList.add('overflow-hidden');
        } else {
          // Only remove if no other overlay is still active
          const hasMenuOpen = document.body.classList.contains('menu-open');
          const hasSearchOpen = document.body.classList.contains('search-overlay-on');
          if (!hasMenuOpen && !hasSearchOpen) {
            document.body.classList.remove('overflow-hidden');
          }
        }
    
        const submenu = menu.closest('li')?.querySelector('.nav_submenu_outer');
        if (!submenu) return;
    
        const tabbableSelectors = ['select', 'input', 'textarea', 'button', 'a[href]'];
        const tabbables = Array.from(submenu.querySelectorAll(tabbableSelectors.join(',')))
          .filter(el =>
            !el.hasAttribute('disabled') &&
            el.getAttribute('aria-hidden') !== 'true' &&
            el.offsetParent !== null
          );
    
        if (tabbables.length === 0) return;
    
        const firstTabbable = tabbables[0];
        const lastTabbable = tabbables[tabbables.length - 1];
    
        setTimeout(() => {
          firstTabbable.focus();
        }, 500);
    
        // Remove existing listeners if any
        firstTabbable.removeEventListener('_keydownHandled', firstTabbable._handler);
        lastTabbable.removeEventListener('_keydownHandled', lastTabbable._handler);
    
        // Backward tab from first element
        firstTabbable._handler = function (e) {
          if (e.key === 'Tab' && e.shiftKey) {
            menu.setAttribute('aria-expanded', 'false');
          }
        };
        firstTabbable.addEventListener('keydown', firstTabbable._handler);
        firstTabbable.addEventListener('_keydownHandled', firstTabbable._handler);
    
        // Forward tab from last element
        lastTabbable._handler = function (e) {
          if (e.key === 'Tab' && !e.shiftKey) {
            menu.setAttribute('aria-expanded', 'false');
          }
        };
        lastTabbable.addEventListener('keydown', lastTabbable._handler);
        lastTabbable.addEventListener('_keydownHandled', lastTabbable._handler);

        // ESCAPE‑KEY HANDLING
        const escHandler = e => {
          if (e.key === 'Escape' || e.key === 'Esc') {
            menu.setAttribute('aria-expanded', 'false');
            menu.focus();
            submenu.removeEventListener('keydown', escHandler);
          }
        };
        submenu.addEventListener('keydown', escHandler);
      });
    });    

    // Desktop mega menu can open via hover/focus (CSS), so also lock scroll while it's open.
    const shouldKeepOverflowHidden = () => {
      const hasMenuOpen = document.body.classList.contains('menu-open');
      const hasSearchOpen = document.body.classList.contains('search-overlay-on');
      const hasAnyHeaderMegaOpen = Array.from(document.querySelectorAll('[data-toggle-menu]'))
        .some(btn => btn.getAttribute('aria-expanded') === 'true');
      const hasAnyHoverOpen = Array.from(document.querySelectorAll('.wt-header__nav-teaser__item.megaMenu_active'))
        .some(item => item.classList.contains('megaMenu_hover_open'));
      return hasMenuOpen || hasSearchOpen || hasAnyHeaderMegaOpen || hasAnyHoverOpen;
    };

    const syncBodyOverflowHidden = () => {
      if (shouldKeepOverflowHidden()) document.body.classList.add('overflow-hidden');
      else document.body.classList.remove('overflow-hidden');
    };

    const headerMegaItems = document.querySelectorAll('.wt-header__nav-teaser__item.megaMenu_active');
    headerMegaItems.forEach((item) => {
      const open = () => {
        item.classList.add('megaMenu_hover_open');
        document.body.classList.add('overflow-hidden');
      };
      const close = () => {
        item.classList.remove('megaMenu_hover_open');
        syncBodyOverflowHidden();
      };

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (e) => {
        // Only close when focus leaves the whole menu item (not just moving within it)
        if (!item.contains(e.relatedTarget)) close();
      });
    });

  /* Product reveiw pagination */
  setTimeout(function() {
    const shadowHost = document.querySelector('[data-bv-show="reviews"]');
    const shadowRoot = shadowHost?.shadowRoot;

    if (!shadowRoot) {
      return;
    }

    const prevTitle = shadowRoot.querySelector('li .prev svg title');
    const nextTitle = shadowRoot.querySelector('li .next svg title');

    if (prevTitle) prevTitle.textContent = 'Prev';
    if (nextTitle) nextTitle.textContent = 'Next';

    const ratingStarSvgs = shadowRoot.querySelectorAll('.bv-reviews-product-rating-star svg');
    ratingStarSvgs.forEach((svg) => {
      const title = document.createElement('title');
      title.textContent = 'Star';
      svg.insertBefore(title, svg.firstChild);
    });

    const searchInput = shadowRoot.querySelector('#search-input');

    if (searchInput) {
      // Link the help text to the input
      searchInput.setAttribute('aria-describedby', 'reviewSearchSuggestionsHelp');

      // Create the help text element
      const helpText = document.createElement('span');
      helpText.id = 'reviewSearchSuggestionsHelp';
      helpText.textContent =
        'As you type, search suggestions will appear below the search box.';

      // Apply the “visually‑hidden” styles
      Object.assign(helpText.style, {
        position: 'absolute',
        width: '1px',
        height: '1px',
        margin: '-1px',
        border: '0',
        padding: '0',
        clip: 'rect(0, 0, 0, 0)', // classic clipping technique
        overflow: 'hidden',
      });

      // Insert it right after #search-input
      searchInput.insertAdjacentElement('afterend', helpText);
    }

    const minimalistButtons = shadowRoot.querySelectorAll('#bv_review_maincontainer div button');
    minimalistButtons.forEach(button => {
      button.style.color = '#dc2c69';
    });

    const reviewWrapper = shadowRoot.querySelectorAll('.bv-rnr__di1qf-6.dylmYa');
    reviewWrapper.forEach(wrapper => {
      wrapper.style.textWrap = 'nowrap';
    });
  }, 5000);

  setTimeout(function() {
    const shadowHost = document.querySelector('[data-bv-show="reviews"]');
    const shadowRoot = shadowHost?.shadowRoot;

    if (!shadowRoot) {
      return;
    }

    const reviewWrapper = shadowRoot.querySelectorAll('.bv-rnr__di1qf-6.dylmYa');
    reviewWrapper.forEach(wrapper => {
      wrapper.style.textWrap = 'nowrap';
    });
  }, 1000)
  /* End Product reveiw pagination */

  /* swiper-pagination-bullet */
  setTimeout(function() {
    const bulletSvgs = document.querySelectorAll('.swiper-pagination-bullet svg');
    bulletSvgs.forEach((svg) => {
      const title = document.createElement('title');
      title.textContent = 'dot';
      svg.insertBefore(title, svg.firstChild);
    });
  }, 2000);
  /* End swiper-pagination-bullet */

  /* Fearture products */
  setTimeout(function () {
    const featuredReviews = document.querySelectorAll('.card__container .bv_main_container');

    if (!featuredReviews || featuredReviews.length === 0) {
      return;
    }

    featuredReviews.forEach((review) => {
      const reviewContainer = document.createElement('div');

      const reviewLabel = review.getAttribute('aria-label');
      const card = review.closest('.card__container')?.querySelector('.card');

      if (card && reviewLabel) {
        const cardLabel = card.getAttribute('aria-label')?.replace('   ', reviewLabel);
        if (cardLabel) {
          card.setAttribute('aria-label', cardLabel);
        }
      }

      reviewContainer.innerHTML = review.innerHTML;
      review.parentElement.innerHTML = reviewContainer.innerHTML;

    });
  }, 5000);
  /* End Fearture products */

  setTimeout(() => {
    const paginationContainers = document.querySelectorAll('.wt-slider__container--video-carousel .wt-slider__pagination, .wt-test__container .wt-slider__pagination');
  
    paginationContainers.forEach((container) => {
      const bullets = container.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach((bullet, i) => {
        bullet.setAttribute('role', 'group');
        bullet.setAttribute('aria-label', `Slide ${i + 1} of ${bullets.length}`);
        bullet.setAttribute('aria-roledescription', 'slide');
      });
    });
  }, 5000);  

  /* playPausebutton for video */
  const playPauseButtons = document.querySelectorAll('[playPausebutton]');
  playPauseButtons.forEach((btn) => {
    let isPlaying = true;
    btn.addEventListener('click', () => {
      isPlaying = !isPlaying;
      const videos = btn.parentElement?.querySelectorAll('video') || [];

      if (!videos.length) {
        return;
      }

      videos.forEach((video) => {
        if (isPlaying) {
          video.autoplay = true;
          video.loop = true;

          video.play();
          btn.classList.remove('shoppable-video__control-button--pause');
          btn.classList.add('shoppable-video__control-button--play');
        } else {
          video.autoplay = false;
          video.loop = false;
          isPlaying = false;
          setTimeout(() => {
            video.pause();
          }, 10);

          btn.classList.remove('shoppable-video__control-button--play');
          btn.classList.add('shoppable-video__control-button--pause');
        }
        video.setAttribute('isPlaying', isPlaying);
      });
    });
  });
  /* End playPausebutton for video */

  /* section/brands.liquid - marquee */
  const playPauseSliders = document.querySelectorAll('[playPauseSlider]');
  playPauseSliders.forEach((btn) => {
    btn.addEventListener('click', () => {
      const parent = btn.parentElement;
      if (parent.classList.contains('pause')) {
        parent.classList.remove('pause');
        btn.classList.remove('shoppable-video__control-button--pause');
        btn.classList.add('shoppable-video__control-button--play');
        btn.setAttribute('aria-label', 'Pause');
      } else {
        parent.classList.add('pause');
        btn.classList.remove('shoppable-video__control-button--play');
        btn.classList.add('shoppable-video__control-button--pause');
        btn.setAttribute('aria-label', 'Play');
      }
  
    });
  });
  /* End section/brands.liquid - marquee */

  /* Product page gallery change tabindex */
  document.querySelectorAll(".thumbs-list-item[data-swiper-slide]").forEach(function (thumb) {
    thumb.addEventListener('click', () => {
      setTimeout(() => {
        document.querySelectorAll(".wt-slider__slide[data-swiper-slide]").forEach((slide) => {
          const link = slide.querySelector('a');
          if (link) {
            link.setAttribute('tabindex', '-1');
          }
        });
  
        const activeSlide = document.querySelector(".wt-slider__slide.swiper-slide-active[data-swiper-slide]");
        if (activeSlide) {
          const activeLink = activeSlide.querySelector('a');
          if (activeLink) {
            activeLink.setAttribute('tabindex', '0');
          }
        }
      }, 1000);
    });
  });
  // Gallery navigation buttons
  document.querySelectorAll('[data-gallery] .wt-slider__nav-btn').forEach(btn => {
    btn.setAttribute('tabindex', '0');
    btn.addEventListener('click', () => {
      setTimeout(() => {
        document.querySelectorAll(".wt-slider__slide[data-swiper-slide]").forEach((slide) => {
          const link = slide.querySelector('a');
          if (link) {
            link.setAttribute('tabindex', '-1');
          }
        });
  
        const activeSlide = document.querySelector(".wt-slider__slide.swiper-slide-active[data-swiper-slide]");
        if (activeSlide) {
          const activeLink = activeSlide.querySelector('a');
          if (activeLink) {
            activeLink.setAttribute('tabindex', '0');
          }
        }
      }, 1000);
    });
  });
  /* End product page gallery change tabindex */

  /* Real video section: video transcript */
  const videoElements = document.querySelectorAll('.wt-slider__container .video-carousel video');
  const transcriptPanels = document.querySelectorAll('.transcript-tab');

  videoElements.forEach((video, index) => {

    const transcriptBtns = video.closest('.video-container')?.querySelectorAll('.transcript span') || [];

    if (transcriptBtns.length > 0) {
      transcriptBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const time = toSeconds(btn.dataset.time);
          if (!isNaN(time)) {
            video.currentTime = time;
            video.play();

            transcriptBtns.forEach(spn => spn.classList.remove('active'));
            btn.classList.add('active');
          }
        });
      });

      let currentActive = null; // remember the last active <span>

      video.addEventListener('timeupdate', () => {
        const now   = video.currentTime;
        const total = video.duration;

        // 1 · Find which <span> *should* be active right now
        let nextActive = null;
        for (let i = 0; i < transcriptBtns.length; i++) {
          const start = toSeconds(transcriptBtns[i].dataset.time);
          const end   = i + 1 < transcriptBtns.length
                          ? toSeconds(transcriptBtns[i + 1].dataset.time)
                          : total;

          if (!isNaN(start) && !isNaN(end) && now >= start && now < end) {
            nextActive = transcriptBtns[i];
            break;
          }
        }

        // 2 · If nothing changed, leave the DOM alone
        if (nextActive === currentActive) return;

        // 3 · Swap classes only on the elements that changed
        if (currentActive) currentActive.classList.remove('active');
        if (nextActive) {
          nextActive.classList.add('active');

          // 4 · Auto‑scroll so the active line stays in view
          const panel = nextActive.closest('#transcript-panel');
          if (panel) {
            panel.scrollTo({
              top: nextActive.offsetTop - 10,
              behavior: 'smooth'
            });
          }
        }

        currentActive = nextActive;   // remember for the next tick
      });
    }
  });

  function toSeconds(timeStr) {
    if (!timeStr.includes(':')) return parseFloat(timeStr);
  
    return timeStr
      .split(':')
      .reverse()
      .reduce((total, val, i) => total + parseFloat(val) * Math.pow(60, i), 0);
  }

  // 1. Toggle the panel when a .transcript-tab is clicked
  const transcriptTabs = document.querySelectorAll('.transcript-tab');
  const videoContainers = document.querySelectorAll('.video-container');

  transcriptTabs.forEach(tab => {
    tab.addEventListener('click', e => {
      e.stopPropagation();                           // don’t let the click bubble to <document>
      const panel = tab.closest('.video-container')
                        .querySelector('#transcript-panel');
      panel.classList.toggle('hidden');
    });
  });

  // 2. Close any open panel when the user clicks outside *its* .video-container
  document.addEventListener('click', e => {
    videoContainers.forEach(container => {
      if (!container.contains(e.target)) {
        const panel = container.querySelector('#transcript-panel');
        if (!panel?.classList.contains('hidden')) {
          panel?.classList.add('hidden');
        }
      }
    });
  });
  /* End real video section: video transcript */

  /* Featured collection section: arrow focus issue */
  const featured_slider = document.querySelectorAll('.wt-slider__container--featured.wt-slider__container .card__container .card');
  featured_slider.forEach(btn => {
    btn.addEventListener('focus', event => {
      btn.closest('.wt-slider__container--featured').querySelectorAll('.wt-slider__nav-btn:not(.swiper-button-disabled)').forEach((nav)=> {
        nav.setAttribute('tabindex','0');
        nav.style.display = 'flex';
      })
    });
  });
  /* End Featured collection section: arrow focus issue */

  /* Contact us form: field-input */
  const contactForm = document.querySelector('.contact-us-form');
  if (contactForm) {
    const fieldInputs = contactForm.querySelectorAll('.field-input');
    fieldInputs.forEach(input => {
      input.addEventListener('keyup', () => {
        if (input.value.length > 0) {
          input.parentElement.classList.add('has-value');
        } else {
          input.parentElement.classList.remove('has-value');
        }
      });
    });
  }
  /* End Contact us form: field-input */
  
  /* Footer: remove tabindex from collapse trigger on desktop */
  const footerTitles = document.querySelectorAll('.wt-footer__title.wt-collapse__trigger');
  const mediaQuery = window.matchMedia('(min-width: 899.98px)');

  function handleTabIndex(e) {
    footerTitles.forEach(title => {
      if (e.matches) {
        title.removeAttribute('aria-expanded');
      } else {
        title.setAttribute('aria-expanded', 'false');
      }
    });
  }

  mediaQuery.addEventListener('change', handleTabIndex);
  handleTabIndex(mediaQuery);
  /* End Footer: remove tabindex from collapse trigger on desktop */

});